import { Link } from 'react-router';
import { PageHeader } from '../app/Shell';
import { Empty } from '../ui';

export function NotFoundPage() {
  return (
    <>
      <PageHeader title="找不到頁面" />
      <Empty>
        這個頁面不存在。<Link to="/">返回總覽</Link>
      </Empty>
    </>
  );
}
